// Canonical Snowflake SQL vocabulary emitted by the custom analytics compiler.
// Admin debug syntax highlighting and display formatting import from here.
export const SnowflakeSqlKeyword = {
  And: "AND",
  As: "AS",
  Asc: "ASC",
  By: "BY",
  DatePartDay: "day",
  Desc: "DESC",
  Distinct: "DISTINCT",
  False: "FALSE",
  From: "FROM",
  GroupBy: "GROUP BY",
  Having: "HAVING",
  Ilike: "ILIKE",
  In: "IN",
  InnerJoin: "INNER JOIN",
  Is: "IS",
  IsDistinctFrom: "IS DISTINCT FROM",
  IsNotNull: "IS NOT NULL",
  IsNull: "IS NULL",
  LeftJoin: "LEFT JOIN",
  Like: "LIKE",
  Limit: "LIMIT",
  Not: "NOT",
  NotIn: "NOT IN",
  Null: "NULL",
  On: "ON",
  Or: "OR",
  OrderBy: "ORDER BY",
  Select: "SELECT",
  True: "TRUE",
  Where: "WHERE",
  With: "WITH",
  WithinGroup: "WITHIN GROUP",
} as const;

export const SnowflakeSqlFunction = {
  AnyValue: "ANY_VALUE",
  ArrayAgg: "ARRAY_AGG",
  ArrayContains: "ARRAY_CONTAINS",
  ArraySize: "ARRAY_SIZE",
  ArraySlice: "ARRAY_SLICE",
  ArrayToString: "ARRAY_TO_STRING",
  Avg: "AVG",
  Coalesce: "COALESCE",
  Concat: "CONCAT",
  ConvertTimezone: "CONVERT_TIMEZONE",
  Count: "COUNT",
  CurrentDate: "CURRENT_DATE",
  CurrentTimestamp: "CURRENT_TIMESTAMP",
  DateAdd: "DATEADD",
  DateTrunc: "DATE_TRUNC",
  Div0: "DIV0",
  Iff: "IFF",
  Lower: "LOWER",
  Max: "MAX",
  Min: "MIN",
  NullIf: "NULLIF",
  RegexpReplace: "REGEXP_REPLACE",
  Split: "SPLIT",
  SplitPart: "SPLIT_PART",
  Substring: "SUBSTRING",
  Sum: "SUM",
  ToDate: "TO_DATE",
  ToTimestampNtz: "TO_TIMESTAMP_NTZ",
  Trim: "TRIM",
  Upper: "UPPER",
} as const;

export const SnowflakeSqlDataType = {
  Boolean: "BOOLEAN",
  Date: "DATE",
  Number: "NUMBER",
  String: "STRING",
  TimestampNtz: "TIMESTAMP_NTZ",
  Variant: "VARIANT",
} as const;

export const NativeSnowflakeFunctionSql = {
  cardinality: SnowflakeSqlFunction.ArraySize,
  coalesce: SnowflakeSqlFunction.Coalesce,
  concat: SnowflakeSqlFunction.Concat,
  date_add: SnowflakeSqlFunction.DateAdd,
  date_floor: SnowflakeSqlFunction.DateTrunc,
  if: SnowflakeSqlFunction.Iff,
  lower: SnowflakeSqlFunction.Lower,
  nullif: SnowflakeSqlFunction.NullIf,
  safe_divide: SnowflakeSqlFunction.Div0,
  split_nth: SnowflakeSqlFunction.SplitPart,
  substring: SnowflakeSqlFunction.Substring,
  trim: SnowflakeSqlFunction.Trim,
  upper: SnowflakeSqlFunction.Upper,
} as const;

export const SnowflakeCompilerSqlDisplayClauseKeywords = [
  SnowflakeSqlKeyword.InnerJoin,
  SnowflakeSqlKeyword.LeftJoin,
  SnowflakeSqlKeyword.GroupBy,
  SnowflakeSqlKeyword.OrderBy,
  SnowflakeSqlKeyword.Select,
  SnowflakeSqlKeyword.From,
  SnowflakeSqlKeyword.Where,
  SnowflakeSqlKeyword.Having,
  SnowflakeSqlKeyword.Limit,
  SnowflakeSqlKeyword.With,
  SnowflakeSqlKeyword.On,
  SnowflakeSqlKeyword.And,
] as const;

const SnowflakeCompilerSqlPhrases = [
  ...Object.values(SnowflakeSqlKeyword),
  ...Object.values(SnowflakeSqlFunction),
  ...Object.values(SnowflakeSqlDataType),
] as const;

export const SnowflakeCompilerSqlTokenWords = [
  ...new Set(
    SnowflakeCompilerSqlPhrases.flatMap((phrase) =>
      phrase.toUpperCase().split(/\s+/),
    ),
  ),
];

export type SnowflakeCompilerSqlDisplayClauseKeyword =
  (typeof SnowflakeCompilerSqlDisplayClauseKeywords)[number];
